import * as ko from "knockout";
import { RNSAPI } from "../../api";
import '../extended/new';
import "moment/locale/de";
import * as fs from 'fs';
import * as moment from "moment"
import { MainViewModel } from "../../main";

export class ProtocolViewModel {
    filteredTodos: ko.Computed<any>;
    hasAutomationModule = ko.observable(false);
    currentTab = ko.observable("classic");
    filter = ko.observable("");
    showClassicTab = () => {
        this.currentTab("classic");
        this.values().stopped(true);
        this.values().nodata(false);
        this.selectedFilterStandort("");
        this.update();
    };
    showAutomationTab = () => {
        if (!this.hasAutomationModule())
            return;
        this.currentTab("automation");
        this.values().stopped(false);
        this.values().nodata(true);
        this.selectedFilterStandort("");
        this.update();
    };
    filterType(type: string) {
        if (type == 'deadline') {
            this.types().deadline(this.checkDeadline())
        }
        else if (type == 'appointment') {
            this.types().appointment(this.checkApp())
        }
        else if (type == 'inbox') {
            this.types().inbox(this.checkInbox())
        }
        this.filter(this.filter());
    }
    checkApp = ko.observable(true);
    checkInbox = ko.observable(true);
    checkDeadline = ko.observable(true);
    sachbearbeiter = ko.observable("");
    values = ko.observable({
        complete: ko.observable(false),
        green: ko.observable(true),
        yellow: ko.observable(true),
        red: ko.observable(true),
        server: ko.observable(true),
        stopped: ko.observable(true),
        nodata: ko.observable(true)
    });
    types = ko.observable({
        deadline: ko.observable(true),
        appointment: ko.observable(true),
        inbox: ko.observable(true)
    });
    AllReferate = ko.observable();
    showTermine = ko.observable(false);
    showInboxes = ko.observable(false);
    showFristen = ko.observable(false);
    todos = ko.observableArray([]);
    selectedFilterStandort = ko.observable("");
    rStartDate = ko.observable("");
    rEndDate = ko.observable("");
    lastSyncDate = ko.observable("");
    lastSyncTime = ko.observable("");
    selectedStatus = ko.observable(0);
    syncDeadline = ko.observable(true);
    outlookError = ko.observable(false);
    outlookExport = ko.observable(false);
    outlookPending = ko.observable(false);
    transmissionTarget = ko.observable("Outlook");
    noRelevantDataCurrent = ko.observable(false);
    transmisionMethod = ko.observable("");
    currentType = ko.observable("");
    currentTaskId = ko.observable(0);
    showError = ko.observable(false);
    modalTitle = ko.observable("");
    modalKeys = ko.observableArray([]);
    modalColumns = ko.observableArray([]);
    modalData = ko.observableArray([]);
    modalHandleSelection = ko.observable();

    async pickGeneric(title, keys, columns, data) {
        this.modalTitle(title);
        this.modalKeys(keys);
        this.modalColumns(columns);
        this.modalData(data);
    };

    filterWithStars(item, filters) {
        if (item['stars'] && filters.indexOf(item['stars']) !== -1) return true;
        return false;
    }

    filterWithType(item, filters) {
        if (item['entryTypeName'] && filters.indexOf(item['entryTypeName']) !== -1) return true
        return false
    }

    filterWithStandort(item) {
        if (item['ref'] && ko.toJS(this.selectedFilterStandort) === item['ref']) return true
        return false
    }

    async pickClerk() {
        let sachbearbeiter = (await RNSAPI.getSachbearbeiter()).Payload.Clerks.filter(s => s.Sachbearbeiter_ID.trim() !== "");
        this.pickGeneric("Fristenkontrolle wählen", ["Sachbearbeiter"], ["Fristenkontrolle"], sachbearbeiter);
        this.modalHandleSelection((selectedObject) => {
            this.sachbearbeiter(selectedObject()["Sachbearbeiter_ID"]);
        });
        $('#modal').modal('show');
    };

    async getReferate() {
        let res = (await RNSAPI.getReferate()).Payload.Units;
        this.AllReferate(res);
    }

    async update() {
        if (this.currentTab() === "automation") {
            this.showFristen(false);
            this.showTermine(false);
            this.showInboxes(false);
            this.todos(await this.getAutomationTasks());
            return;
        }

        let deadlines = await this.getDeadlineTasks();
        let appointments = await this.getAppointmentTasks();
        let inboxes = await this.getInboxTasks();

        if (deadlines.length > 0)
            this.showFristen(true);
        else
            this.showFristen(false);
        if (appointments.length > 0)
            this.showTermine(true);
        else
            this.showTermine(false);
        if (inboxes.length > 0)
            this.showInboxes(true);
        else
            this.showInboxes(false);
        this.todos(deadlines.concat(appointments).concat(inboxes));
    }

    async getAppointmentTasks() {
        let res = (await RNSAPI.getAppointmentProtocolTasks(moment(ko.toJS(this.rStartDate)), moment(ko.toJS(this.rEndDate))));
        let mappedAppointments = res as any;
        return this.mapEntries(mappedAppointments, "appointment");
    }

    async getDeadlineTasks() {
        let res = (await RNSAPI.getDeadlineProtocolTasks(moment(ko.toJS(this.rStartDate)), moment(ko.toJS(this.rEndDate))));
        let mappedDeadlines = res as any;
        return this.mapEntries(mappedDeadlines, "deadline");
    }

    async getInboxTasks() {
        let res = (await RNSAPI.getInboxProtocolTasks(moment(ko.toJS(this.rStartDate)), moment(ko.toJS(this.rEndDate))));
        let mappedMails = res as any;
        return this.mapEntries(mappedMails, "inbox");
    }

    async getAutomationTasks() {
        let res = (await RNSAPI.getAutomationProtocolTasks(moment(ko.toJS(this.rStartDate)), moment(ko.toJS(this.rEndDate))));
        let mappedAutomations = res as any;
        return this.mapEntries(mappedAutomations, "automation");
    }

    async setTaskState(reactivate: boolean) {
        switch (ko.toJS(this.currentType)) {
            case "inbox":
                await RNSAPI.setTaskStateInbox(ko.toJS(this.currentTaskId), reactivate).then((response) => {
                    this.update();
                    $("#stateModal").modal("hide");
                }).catch((error) => {
                    console.log(error);
                    this.showError(true);
                    setTimeout(() => {
                        this.showError(false);
                    }, 3000);
                });
                break;
            case "deadline":
                await RNSAPI.setTaskStateDeadline(ko.toJS(this.currentTaskId), reactivate).then((response) => {
                    this.update();
                    $("#stateModal").modal("hide");
                }).catch((error) => {
                    console.log(error);
                    this.showError(true);
                    setTimeout(() => {
                        this.showError(false);
                    }, 3000);
                });
                break;
            case "appointment":
                await RNSAPI.setTaskStateAppointment(ko.toJS(this.currentTaskId), reactivate).then((response) => {
                    this.update();
                    $("#stateModal").modal("hide");
                }).catch((error) => {
                    console.log(error);
                    this.showError(true);
                    setTimeout(() => {
                        this.showError(false);
                    }, 3000);
                });
                break;
            case "automation":
                await RNSAPI.setTaskStateAutomation(ko.toJS(this.currentTaskId), reactivate).then((response) => {
                    this.update();
                    $("#stateModal").modal("hide");
                }).catch((error) => {
                    console.log(error);
                    this.showError(true);
                    setTimeout(() => {
                        this.showError(false);
                    }, 3000);
                });
                break;
        }
    }


    blockTask() {
        this.setTaskState(false);
    }

    reactivateTask() {
        this.setTaskState(true);
    }

    mapEntries(input, type) {
        let mappedDeadlines = input as any;
        mappedDeadlines = mappedDeadlines.map((a) => {
            a.entryTypeName = type === "automation" ? "automation" : type;

            if (a.TaskState === 0)
                a.stars = "yellow";
            else if (a.TaskState === 1)
                a.stars = "red";
            else if (a.TaskState === 2)
                a.stars = "complete";
            else if (a.TaskState === 3)
                a.stars = "stopped";
            else if (a.TaskState === 4)
                a.stars = "server";
            if (type === "automation" && a.NoRelevantData === true)
                a.stars = "nodata";

            a.transmission = moment(a.CreatedAt).format("DD.MM.YYYY HH:mm");
            a.ExternalSoftwareName = type === "automation" ? "Automatisierte Reports" : "Outlook";

            const executionMoment = moment(a.date);
            a.date = executionMoment.format("DD.MM.YYYY");
            a.executionAt = executionMoment.format("DD.MM.YYYY HH:mm");
            a.ref = a.referat;

            a.columnActions = {};
            if (a.number) {
                a.columnActions = {
                    "number": MainViewModel.RoutingTable.generateLink(`/new/${encodeURIComponent(a.number)}`)
                };
            }

            let editTask = {
                icon: "info-circle", name: "Übertragungsinformationen", action: async () => {
                    this.syncDeadline(true);
                    this.currentType(type);
                    this.currentTaskId(a.Id);
                    this.transmissionTarget(a.ExternalSoftwareName || "Outlook");
                    this.noRelevantDataCurrent(a.NoRelevantData === true);

                    if (type === "automation")
                        this.transmisionMethod("Automatisierter Report");
                    else if (a.Method === 0 && type !== "inbox" && type !== "Outbox")
                        this.transmisionMethod("Anlage");
                    else if (a.Method === 0 && (type === "Inbox" || type === "Outbox"))
                        this.transmisionMethod("Abschluss (" + type + ")");
                    else if (a.Method === 1 && type !== "Inbox" && type !== "Outbox")
                        this.transmisionMethod("Verschiebung");
                    else if (a.Method === 1 && (type === "Inbox" || type === "Outbox"))
                        this.transmisionMethod("Mail-Versand (" + type + ")");
                    else if (a.Method === 2)
                        this.transmisionMethod("Erledigung");
                    else if (a.Method === 3) {
                        if (a.entryTypeName === "deadline")
                            this.transmisionMethod("Instanzen Aktualisierung");
                        else
                            this.transmisionMethod("Löschung");
                    }
                    else if (a.Method === 4) {
                        if (a.entryTypeName === "deadline")
                            this.transmisionMethod("FVA gestellt");
                        else
                            this.transmisionMethod("Instanzen Aktualisierung");
                    }
                    else if (a.Method === 5) {
                        if (a.entryTypeName === "deadline")
                            this.transmisionMethod("FVA abgelehnt");
                        else
                            this.transmisionMethod("Versäumnis");
                    }
                    else if (a.Method === 6) {
                        if (a.entryTypeName === "deadline")
                            this.transmisionMethod("FVA bewilligt");
                        else
                            this.transmisionMethod("Instanz-Verschiebung");
                    }
                    else if (a.Method === 7) {
                        if (a.entryTypeName === "deadline")
                            this.transmisionMethod("Löschung");
                    }
                    else if (a.Method === 8) {
                        if (a.entryTypeName === "deadline")
                            this.transmisionMethod("Versäumnis");
                    }
                    else if (a.Method === 9) {
                        if (a.entryTypeName === "deadline")
                            this.transmisionMethod("Instanz-Verschiebung");
                    }

                    this.outlookExport(false);

                        this.outlookExport(true);
                        if (a.NoRelevantData === true) {
                            this.outlookPending(false);
                            this.outlookError(false);
                        }
                        else if (a.TaskState === 0) {
                            this.outlookPending(true);
                            this.outlookError(false);
                        }
                        else {
                            this.outlookPending(false);
                            if (a.TaskState === 2)
                                this.outlookError(false);
                            else
                                this.outlookError(true);
                        }

                    if (a.LastSync) {
                        this.lastSyncDate(moment(a.LastSync).format("YYYY-MM-DD"));
                        this.lastSyncTime(moment(a.LastSync).format("HH:mm"));
                    }
                    else {
                        this.lastSyncDate("YYYY-MM-DD");
                        this.lastSyncTime("HH:mm");
                    }
                    this.selectedStatus(a.TaskState);

                    $("#stateModal").modal("show");
                }
            }

            a.actionHandlers = [];
            a.actionHandlers.push(editTask);
            return a;
        });
        return mappedDeadlines;
    }

    constructor() {
        this.rStartDate(ko.toJS(moment().format("YYYY-MM-DD")));
        this.rEndDate(ko.toJS(moment().format("YYYY-MM-DD")));
        const user = RNSAPI.getCurrentLoggedInUser();
        if (ko.toJS(user.UseAutomation) === "1")
            this.hasAutomationModule(true);

        this.getReferate();
        this.update();

        this.filteredTodos = ko.computed({
            owner: this,
            read: () => {
                let filter = this.filter()
                let sachbearbeiter = this.sachbearbeiter()
                let filters = []

                if (this.values().complete()) {
                    filters.push('complete')
                } else {
                    filters.indexOf('complete') !== -1 ? filters.splice(filters.indexOf('complete'), 1) : null
                }

                if (this.values().green()) {
                    filters.push('green')
                } else {
                    filters.indexOf('green') !== -1 ? filters.splice(filters.indexOf('green'), 1) : null
                }

                if (this.values().yellow()) {
                    filters.push('yellow')
                } else {
                    filters.indexOf('yellow') !== -1 ? filters.splice(filters.indexOf('yellow'), 1) : null
                }
                if (this.values().red()) {
                    filters.push('red')
                } else {
                    filters.indexOf('red') !== -1 ? filters.splice(filters.indexOf('red'), 1) : null
                }
                if (this.values().server()) {
                    filters.push('server')
                } else {
                    filters.indexOf('server') !== -1 ? filters.splice(filters.indexOf('server'), 1) : null
                }
                if (this.values().stopped()) {
                    filters.push('stopped')
                } else {
                    filters.indexOf('stopped') !== -1 ? filters.splice(filters.indexOf('stopped'), 1) : null
                }
                if (this.values().nodata()) {
                    filters.push('nodata')
                } else {
                    filters.indexOf('nodata') !== -1 ? filters.splice(filters.indexOf('nodata'), 1) : null
                }

                const filterTypes = Object.keys(this.types()).filter(item => this.types()[item]())

                let items = this.todos();

                if (this.currentTab() === "classic" && ko.toJS(this.selectedFilterStandort()) !== "")
                    items = items.filter(item => this.filterWithStandort(item))



                if (filters.length) {
                    items = items.filter(item => this.filterWithStars(item, filters))
                }

                if (this.currentTab() === "classic" && filterTypes.length) {
                    items = items.filter(item => this.filterWithType(item, filterTypes))
                }
                if (filter) {
                    const q = filter.toLowerCase();
                    if (this.currentTab() === "automation") {
                        items = items.filter(item =>
                            (item['subject'] && String(item['subject']).toLowerCase().indexOf(q) !== -1) ||
                            (item['rubrum'] && String(item['rubrum']).toLowerCase().indexOf(q) !== -1)
                        )
                    } else {
                        items = items.filter(item => item['number'] && item['number'].indexOf(filter) !== -1)
                    }
                }
                if (sachbearbeiter) {
                    items = items.filter(item => item['SB'] && item['SB'].includes(sachbearbeiter))
                }

                return items
            }
        });

        this.rStartDate.subscribe(() => this.update());
        this.rEndDate.subscribe(() => this.update());
    }
}

var html = fs.readFileSync(__dirname + '/protocol.html', 'utf8');

ko.components.register("protocol-view", {
    viewModel: ProtocolViewModel,
    template: html
});
